var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceTagIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47254 2.5L13.1841 3.31593L14 9.02748L8.69643 14.331C8.47113 14.5563 8.10586 14.5563 7.8805 14.331L2.16899 8.61952C1.94367 8.39416 1.94367 8.02889 2.16899 7.80353L7.47254 2.5ZM9.10445 7.39557C9.55505 7.84623 10.2856 7.84623 10.7363 7.39557C11.1869 6.94496 11.1869 6.21435 10.7363 5.76372C10.2856 5.3131 9.55505 5.3131 9.10445 5.76372C8.65379 6.21435 8.65379 6.94496 9.10445 7.39557Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTagIconWhite);
export default __webpack_public_path__ + "static/media/PriceTagIconWhite.2c690644ef4da6fb2822431e32990d73.svg";
export { ForwardRef as ReactComponent };